module.exports = __webpack_public_path__ + "static/media/pro.65ef9e26.png";